var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":_vm.formatedValue},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }